import { FC } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { IconsId } from "../../../assets/fonts/iconfont/icons";
import { StyledButton } from "../../atoms/Button/Button";
import Title from "../../atoms/Title/Title";
import { Icon } from "../../atoms/Icon";
import styles from "./permissionOverlay.module.scss";

type FeatureT = {
  icon: IconsId;
  text: string;
};

type PropsT = {
  title: string;
  subtitle: string;
  features: FeatureT[];
  isOpen: boolean;
  allow: VoidFunction;
};

export const PermissionOverlay: FC<PropsT> = ({
  title,
  subtitle,
  features,
  isOpen,
  allow,
}: PropsT) => {
  return (
    <Modal
      className={styles.modal}
      contentClassName={styles.overlay}
      isOpen={isOpen}
      fullscreen
    >
      <ModalHeader className={styles.header}>
        <Title className={styles.title} size="h1">
          {title}
        </Title>
        <p className={styles.subtitle}>{subtitle}</p>
      </ModalHeader>
      <ModalBody className={styles.body}>
        {features.map((feature, idx) => (
          <div className={styles.feature} key={`${feature.icon}-${idx}`}>
            <Icon className={styles.icon} icon={feature.icon} />
            <span className={styles.message}>{feature.text}</span>
          </div>
        ))}
      </ModalBody>
      <ModalFooter className={styles.footer}>
        <div className={styles.footerButtons}>
          <StyledButton
            className={styles.allowButton}
            onClick={allow}
            color="primary"
          >
            Next
          </StyledButton>
        </div>
        <p className={styles.footerMessage}>
          You can change this option later in the settings
        </p>
      </ModalFooter>
    </Modal>
  );
};
